import dayjs from "utils/dayjs";

export interface FinancialAccount {
  id: string;
  accountHolderId: string;
  name: string;
  currency?: string;
  status: string;
  readiness?: string;
  issuer?: string;
  accountType?: string;
  capabilities: string[];
  available: boolean;
  stale?: boolean;
  balance?: {
    available?: number;
    pending?: number;
    outgoing?: number;
    creditLimit?: number;
    outstanding?: number;
    reportedAt?: number;
  };
}
export interface JournalEntry {
  id: string;
  financialAccountId: string;
  sequence: number;
  type: string;
  amount: number;
  currency: string;
  effectiveAt: number;
  recordedAt: number;
  transactionId?: string;
  lines: {
    ledgerAccount: string;
    currency: string;
    debit?: number;
    credit?: number;
  }[];
  references?: {
    financialEventId?: string;
    authorizationId?: string;
    entryIds?: string[];
  };
}
export type ConsoleNavigate = (values: Record<string, string | null>) => void;
export interface ConsoleProps {
  companyId: string;
  params: URLSearchParams;
  navigate: ConsoleNavigate;
}

export const instant = (value?: string | number | null) =>
  value == null ? "Unavailable" : new Date(value).toLocaleString();
export const label = (value?: string | null) =>
  value
    ? value
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/^./, (letter) => letter.toUpperCase())
    : "Unavailable";
export const money = (value?: number | null, currency?: string | null) => {
  if (value == null || !currency) return "Unavailable";
  try {
    const format = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    });
    const digits = format.resolvedOptions().maximumFractionDigits ?? 2;
    return format.format(value / 10 ** digits);
  } catch {
    return "Unavailable";
  }
};
export const dateFilter = (params: URLSearchParams) => {
  const from = params.get("from");
  const to = params.get("to");
  return {
    startDate: from ? dayjs(from).startOf("day").valueOf() : undefined,
    endDate: to ? dayjs(to).endOf("day").valueOf() : undefined,
  };
};
